import Rails from "@rails/ujs"
import "javascripts/guest/auth.js"

Rails.start()
